import isEmpty from 'lodash/isEmpty';
import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

const supportedActions = [
  'GET_CHANNEL_METADATA',
  'ADD_CHANNEL_METADATA',
  'CLEAR',
];

export const consts = createConsts('board', 'metadata', ...supportedActions);
export const actions = createActions(consts);

// init
const initialState = {};

const addChannelMetadata = (state, action) => {
  const { channelId, meta } = action.payload;

  if (isEmpty(meta)) return state;

  const newUsers = meta.reduce((acc, user) => {
    acc[user.id] = user;

    return acc;
  }, {});

  const newChannelMeta = Object.assign({}, state[channelId], newUsers);

  return {
    ...state,
    [channelId]: newChannelMeta,
  };
};

// reducer
const reducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.ADD_CHANNEL_METADATA:
      return addChannelMetadata(state, action);
    case consts.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/board/metadata.js